export default __webpack_public_path__ + "static/media/Vector.12e222be.svg";